import { render } from "./postUpdateOrSave.vue?vue&type=template&id=3cab3106"
import script from "./postUpdateOrSave.vue?vue&type=script&lang=js"
export * from "./postUpdateOrSave.vue?vue&type=script&lang=js"
script.render = render

export default script